module.exports = __webpack_public_path__ + "img/zu23.4b29a9f0.png";